module.exports = __webpack_public_path__ + "static/school_obj9@2x-d6e82231e6051197e015b070838f3518.png";